<p-dialog [(visible)]="displayAddEditDialog" [modal]="true" [closable]="false" [style]="{width: '60vw'}" appendTo="body">
    <!-- <div>Hare Krishna</div> -->
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 50%;">
            <h5 class="p-mb-0">{{ dialogHeader }}</h5>
        </div>
        <div class="p-ml-auto p-d-flex p-ai-center">
            <div *ngIf="casesViewDetails && crudType=='view'" class="p-mr-2">
                <strong> Created by {{ casesViewDetails.createdByUserName }}</strong> {{ casesViewDetails.createdDate }}
            </div>
            <button pButton pRipple *ngIf="casesViewDetails && crudType=='view'" (click)="switchToEdit()"
                class="p-button-text p-button-rounded" icon="pi pi-pencil"></button>
            <button pButton pRipple type="button" icon="pi pi-times" (click)="closeCasesDialog()"
                class="p-button-rounded p-dialog-header-icon p-dialog-header-close"></button>
        </div>

    </ng-template>

    <ng-container *ngIf="casesForm && checkedFields && crudType!='view'">
        <form [formGroup]="casesForm" novalidate>
            <div class="header">
                <h5>
                    {{ templateSections?.[0]?.name||'Cases Information'}}
                    <!-- <p-inputSwitch formControlName="isActive" class="header-switch" [disabled]="crudType=='view'" (onChange)="changeStatus($event)"></p-inputSwitch> -->
                </h5>
            </div>

            <div class="card">
                <div class="p-grid">
                    <div *ngIf="callFromAccountTab && crudType == 'add'" class="p-col-12 p-md-6">
                        <label>Cases Channel <span class="required-sign">*</span></label>
                        <p-dropdown [options]="casesChannelList" formControlName="channelId" optionLabel="name" optionValue="id" appendTo="body" [placeholder]="'Select Cases Channel'" (onChange)="selectedCasesChannel($event.value)">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.channelId" class="p-invalid">
                            <small>{{ detailsFormErrors?.channelId }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.sequenceNumber?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.sequenceNumber?.labelName }} <span
                                *ngIf="checkedFields.sequenceNumber?.isRequired" class="required-sign">*</span></label>
                        <input type="text" pInputText formControlName="sequenceNumber">
                        <div *ngIf="detailsFormErrors?.sequenceNumber" class="p-invalid">
                            <small>{{ detailsFormErrors?.sequenceNumber }}</small>
                        </div>
                    </div>
                </div>
                <div class="p-grid">
                    <div *ngIf="checkedFields.caseAssociationName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.caseAssociationName?.labelName }} <span
                                *ngIf="checkedFields.caseAssociationName?.isRequired"
                                class="required-sign">*</span></label>
                        <p-dropdown [options]="caseAssociationList" formControlName="caseAssociationName"
                            name="caseAssociation" optionLabel="name" placeholder="Case Association" appendTo="body"
                            (onChange)="getAssociationNames($event)" [disabled]="callFromAccountTab">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.caseAssociationName" class="p-invalid">
                            <small>{{ detailsFormErrors?.caseAssociationName }}</small>
                        </div>
                    </div>
                    <div *ngIf="checkedFields.associationName?.enabledInForm  && !['Account','Lead'].includes(casesForm?.get('caseAssociationName').value?.name) && casesForm?.get('caseAssociationName')?.value" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.associationName?.labelName }} <span
                                *ngIf="checkedFields.associationName?.isRequired" class="required-sign">*</span></label>
                        <p-autoComplete formControlName="associationName" [suggestions]="associationNamesSuggestions"
                            field="businessName" [completeOnFocus]="true" (completeMethod)="search($event.query)"
                            (onSelect)="getContactsValues($event.value)" [multiple]="false" appendTo="body"
                            [placeholder]="'Search by name'" [disabled]="callFromAccountTab">
                        </p-autoComplete>
                        <div *ngIf="detailsFormErrors?.associationName" class="p-invalid">
                            <small>{{ detailsFormErrors?.associationName }}</small>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6" *ngIf="checkedFields.associationName?.enabledInForm  && ['Account','Lead'].includes(casesForm?.get('caseAssociationName').value?.name)">
                            <label>{{ checkedFields.associationName?.labelName }} <span
                                *ngIf="checkedFields.associationName?.isRequired" class="required-sign">*</span></label>

                            <div class="association-name">
                                <span (click)="openParentAcountDialog()" *ngIf="!casesForm?.get('associationName')?.value" class="hyper-link"><strong class="association-name"><i class="pi pi-plus p-mr-2"></i> Select {{ checkedFields.associationName?.labelName }}</strong></span>
                                <span (click)="!callFromAccountTab && openParentAcountDialog()" *ngIf="casesForm?.get('associationName')?.value" class="hyper-link">
                                    <strong class="association-name">
                                        @if(!callFromAccountTab){
                                        <i class="pi pi-pencil p-mr-2"></i>
                                        }
                                        <ng-container *ngIf="casesForm?.get('associationName')?.value?.sequenceNumber && casesId < 0">
                                            {{ casesForm?.get('associationName').value?.sequenceNumber }} -
                                        </ng-container>
                                        {{ casesForm?.get('associationName').value?.businessName }}
                                    </strong>
                                    @if(!callFromAccountTab){
                                    <i  (click)="removeParentAccount()" class="pi pi-times p-ml-3"></i>
                                    }

                                </span>
                            </div>
                            <small *ngIf="accountExistMsg.length" class="p-invalid account-not-exists">
                                {{ accountExistMsg }}
                            </small>
                            <div *ngIf="detailsFormErrors?.associationName" class="p-invalid">
                                <small>{{ detailsFormErrors?.associationName }}</small>
                            </div>
                    </div>
                </div>

                <div class="p-grid">
                    <div *ngIf="checkedFields.contactName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.contactName?.labelName }} </label>
                        <p-autoComplete formControlName="contactName" [suggestions]="contactNamesSuggestions"
                            field="contactName" [completeOnFocus]="true" id="contactNames" [showClear]="true"
                            appendTo="body" (completeMethod)="searchContact($event.query)"
                            (onSelect)="getContactsDetails($event.value)" />
                        <div *ngIf="detailsFormErrors?.contactName" class="p-invalid">
                            <small>{{ detailsFormErrors?.contactName }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.contactEmailAddress?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.contactEmailAddress?.labelName }} </label>
                        <p-autoComplete formControlName="contactEmailAddress" [suggestions]="emailAddressSuggestion"
                            field="emailAddress" [completeOnFocus]="true" [showClear]="true" appendTo="body"
                            (completeMethod)="searchEmailAddress($event.query)" (onSelect)="getEmailValues($event.value)">
                        </p-autoComplete>
                        <div *ngIf="detailsFormErrors?.contactEmailAddress" class="p-invalid">
                            <small>{{ detailsFormErrors?.contactEmailAddress }}</small>
                        </div>
                    </div>
                </div>
                <div class="p-grid">
                    <div *ngIf="checkedFields.contactMobileNo?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.contactMobileNo?.labelName }} </label>
                        <p-autoComplete formControlName="contactMobileNo" [suggestions]="phoneNumberSuggestion"
                            field="number" [completeOnFocus]="true" (completeMethod)="searchPhoneNumber($event.query)"
                            (onSelect)="getPhoneNumberValues($event.value)" id="phoneNumberSuggestion" [showClear]="true"
                            appendTo="body">
                        </p-autoComplete>
                        <div *ngIf="detailsFormErrors?.contactMobileNo" class="p-invalid">
                            <small>{{ detailsFormErrors?.contactMobileNo }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.sourceName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.sourceName?.labelName }} </label>
                        <p-dropdown [options]="sources" formControlName="sourceName" optionLabel="name"
                            placeholder="Select Source" [ngModelOptions]="{standalone: true}" appendTo="body">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.sourceName" class="p-invalid">
                            <small>{{ detailsFormErrors?.sourceName }}</small>
                        </div>
                    </div>
                </div>


                <div class="p-grid">
                    <div *ngIf="checkedFields.categoryName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.categoryName?.labelName }}</label>
                        <p-dropdown [options]="categories" formControlName="categoryName" optionLabel="name"
                            placeholder="Select Category" (onChange)="getSubCategories($event)"
                            [ngModelOptions]="{standalone: true}" appendTo="body">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.categoryName" class="p-invalid">
                            <small>{{ detailsFormErrors?.categoryName }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.subCategoryName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.subCategoryName?.labelName }} </label>
                        <p-dropdown [options]="subCategories" formControlName="subCategoryName" optionLabel="name"
                            (onChange)="getSubCategories($event, null, true)" placeholder="Select Sub Category"
                            [ngModelOptions]="{standalone: true}" appendTo="body">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.subCategoryName" class="p-invalid">
                            <small>{{ detailsFormErrors?.subCategoryName }}</small>
                        </div>
                    </div>
                </div>

                <div class="p-grid">
                    <div *ngIf="checkedFields.priorityName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.priorityName?.labelName }}</label>
                        <p-dropdown [options]="priorities" formControlName="priorityName" optionLabel="name"
                            placeholder="Select Priority" [ngModelOptions]="{standalone: true}" appendTo="body">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.priorityName" class="p-invalid">
                            <small>{{ detailsFormErrors?.priorityName }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.subject?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.subject?.labelName }} </label>
                        <input pInputText type="text" formControlName="subject" name="subject">
                        <div *ngIf="detailsFormErrors?.subject" class="p-invalid">
                            <small>{{ detailsFormErrors?.subject }}</small>
                        </div>
                    </div>
                </div>


                <div class="p-grid">
                    <div *ngIf="checkedFields.reportedBy?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.reportedBy?.labelName }} </label>
                        <input pInputText type="text" formControlName="reportedBy" name="reportedBy">
                        <div *ngIf="detailsFormErrors?.reportedBy" class="p-invalid">
                            <small>{{ detailsFormErrors?.reportedBy }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.attachmentLinks?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.attachmentLinks?.labelName }} <span
                                *ngIf="checkedFields.attachmentLinks?.isRequired" class="required-sign">*</span></label>
                        <p-fileUpload [disabled]="disabledEdit" customUpload="true" class="fupload" previewWidth="100"
                            chooseLabel="Choose" [showUploadButton]="false" [showCancelButton]="false" [multiple]="true"
                            (onSelect)="uploadAttachments($event.files)">
                            <ng-template pTemplate="file"></ng-template>
                            <ng-template pTemplate="content">
                                <ng-container *ngFor="let attachment of uploadedFiles;let i=index;">
                                    <ng-container *ngIf="attachment && attachment.statusId === 1">
                                        <div class="p-fileupload-row">
                                            <button type="button" pButton icon="fa fa-download"
                                                (click)="downloadFile(attachment.name, attachment.content, attachment.location)"
                                                class="p-button-link p-px-0 p-py-0" label=""></button>
                                            <div (click)="openFilePreview(attachment)" style="cursor: pointer;">
                                                <ng-container *ngIf="attachment.name.length>15 else splitImageName">
                                                    <div>{{ attachment.name.substring(0, 14) }}...</div>
                                                </ng-container>
                                                <ng-template #splitImageName>
                                                    <div>{{ attachment.name }}</div>
                                                </ng-template>
                                            </div>

                                            <div>{{ (attachment.sizeInBytes / 1024).toFixed(2) + ' KB' }}</div>
                                            <div>
                                                <button icon="pi pi-times" pButton
                                                    (click)="removeAttachment(attachment)" type="button"
                                                    icon="pi pi-times" [disabled]="isDisabledFilesAction">
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-template>
                        </p-fileUpload>
                    </div>
                </div>


                <div class="p-grid">
                    <div *ngIf="checkedFields.ticketDesc?.enabledInForm" class="p-col-12">
                        <label>{{ checkedFields.ticketDesc?.labelName }} <span
                                *ngIf="checkedFields.ticketDesc?.isRequired" class="required-sign">*</span></label>
                        <textarea pInputTextarea formControlName="ticketDesc" rows="7" class="w-100">
                                </textarea>
                        <div *ngIf="detailsFormErrors?.ticketDesc" class="p-invalid">
                            <small>{{ detailsFormErrors?.ticketDesc }}</small>
                        </div>
                    </div>

                    <!-- <div *ngIf="checkedFields.stageName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.stageName?.labelName }} <span
                                *ngIf="checkedFields.stageName?.isRequired" class="required-sign">*</span></label>

                    </div> -->
                </div>

                <div class="p-grid">
                    <div *ngIf="checkedFields.resolutionDate?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.resolutionDate?.labelName }} <span
                                *ngIf="checkedFields.resolutionDate?.isRequired" class="required-sign">*</span></label>
                        <!-- <p-calendar formControlName="resolutionDate" dateFormat="mm/dd/yy" appendTo="body"
                            (onSelect)="detectDateChange($event)">
                        </p-calendar> -->
                        <p-calendar formControlName="resolutionDate" [monthNavigator]="true" [yearNavigator]="true"
                            placeholder="mm/dd/yy" [minDate]="minDateValue" dateFormat="mm/dd/yy" yearRange="1900:2100"
                            [showTime]="false" appendTo="body" styleClass="w-100"
                            [ngClass]="{ 'ng-invalid':  detailsFormErrors?.resolutionDate}"
                            (onSelect)="detectDateChange($event)">
                        </p-calendar>
                        <div *ngIf="detailsFormErrors?.resolutionDate" class="p-invalid">
                            <small>{{ detailsFormErrors?.resolutionDate }}</small>
                        </div>
                    </div>


                </div>

                <div *ngIf="isShowResComments" class="p-grid">
                    <div *ngIf="checkedFields.resolutionComment?.enabledInForm" class="p-col-12">
                        <label>{{ checkedFields.resolutionComment?.labelName }} <span
                                *ngIf="checkedFields.resolutionComment?.isRequired"
                                class="required-sign">*</span></label>
                        <textarea pInputTextarea name="resolutionComment" rows="5" formControlName="resolutionComment"
                            required>
                        </textarea>
                        <div *ngIf="detailsFormErrors?.resolutionComment" class="p-invalid">
                            <small>{{ detailsFormErrors?.resolutionComment }}</small>
                        </div>
                    </div>
                </div>

                <div class="p-grid">
                    <div *ngIf="checkedFields.assignedGroup?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.assignedGroup?.labelName }} <span
                                *ngIf="checkedFields.assignedGroup?.isRequired" class="required-sign">*</span></label>
                        <p-dropdown [options]="groupUserList" formControlName="assignedGroup" optionLabel="name"
                            (onChange)="onSelectedUserGroup($event)" placeholder="Select Groups"
                            [ngModelOptions]="{standalone: true}" appendTo="body">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.assignedGroup" class="p-invalid">
                            <small>{{ detailsFormErrors?.assignedGroup }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.assignedUser?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.assignedUser?.labelName }} </label>
                        <p-dropdown [options]="userList" formControlName="assignedUser" optionLabel="name"
                        (onChange)="onSelectedUser($event)" [showClear]="true" placeholder="Select User" [ngModelOptions]="{standalone: true}" appendTo="body">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.assignedUser" class="p-invalid">
                            <small>{{ detailsFormErrors?.assignedUser }}</small>
                        </div>
                    </div>
                </div>

                <!-- <div class="p-grid">
                    <div *ngIf="checkedFields.createdByName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.createdByName?.labelName }} <span
                                *ngIf="checkedFields.createdByName?.isRequired" class="required-sign">*</span></label>

                    </div>

                    <div *ngIf="checkedFields.createdDate?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.createdDate?.labelName }} <span
                                *ngIf="checkedFields.createdDate?.isRequired" class="required-sign">*</span></label>

                    </div>
                </div> -->


                <!-- Custom Attributes Fields -->
                <div class="p-col-12" formArrayName="customAttributeValues">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6"
                            *ngFor="let customField of getAddedCustomAttributes(casesForm); let itemIndex=index"
                            [formGroupName]="itemIndex">

                            <label>{{ customField.value.labelName }} <span *ngIf="customField.value.isRequired"
                                    class="required-sign">*</span></label>

                            <ng-container [ngSwitch]="customField?.value?.formControlId">
                                <!-- Input -->
                                <ng-container *ngSwitchCase="formControlListIds?.InputBox">
                                    <input pInputText type="text" formControlName="value"
                                        [placeholder]="'Enter value'" />
                                </ng-container>

                                <!-- Dropdown -->
                                <ng-container *ngSwitchCase="formControlListIds?.DropDownList">
                                    <p-dropdown [options]="customField.value.pickListValues"
                                        [placeholder]="'Select ' + customField.value.labelName" formControlName="values"
                                        optionLabel="name" appendTo="body">
                                    </p-dropdown>
                                </ng-container>

                                <!-- Multiple Dropdown -->
                                <ng-container *ngSwitchCase="formControlListIds?.MultipleDropDownList">
                                    <p-multiSelect [options]="customField.value.pickListValues"
                                        [placeholder]="'Select ' + customField.value.labelName"
                                        formControlName="multipleValues" optionLabel="name" appendTo="body">
                                    </p-multiSelect>
                                </ng-container>

                                <!-- CheckBox -->
                                <ng-container *ngSwitchCase="formControlListIds?.CheckBox">
                                    <ng-container *ngFor="let pickName of customField.value.pickListValues">
                                        <p-checkbox [value]="pickName" [formControl]="customField.get('multipleCheckBox')"></p-checkbox>
                                        {{ pickName }}
                                    </ng-container>
                                </ng-container>

                                <!-- File Upload -->
                                <ng-container *ngSwitchCase="formControlListIds?.FileUpload">
                                    <p-fileUpload customUpload="true" class="fupload" previewWidth="100"
                                        chooseLabel="Choose" [showUploadButton]="false" [multiple]="true"
                                        [showCancelButton]="false"
                                        (onSelect)="onCustomUpload($event, customField, 'any')">
                                        <ng-template pTemplate="file"></ng-template>
                                        <ng-template pTemplate="content">
                                            <ng-container
                                                *ngFor="let file of (customField.value.customeAttachement||[]); let i = index;">
                                                <div class="p-fileupload-row" *ngIf="file">
                                                    <button pButton icon="fa fa-download"
                                                        (click)="downloadFile(file.name, file.content)"
                                                        class="p-button-link p-px-0 p-py-0">
                                                    </button>
                                                    <ng-container *ngIf="file.name.length > 15 else splitFileName">
                                                        <div [pTooltip]="file.name">
                                                            {{ file.name.substring(0, 14) }} ...
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #splitFileName>
                                                        <div> {{ file.name }} </div>
                                                    </ng-template>
                                                    <div>
                                                        {{ file.sizeInBytes | fileSize }}
                                                    </div>
                                                    <div>
                                                        <button icon="pi pi-times" pButton
                                                            (click)="removeCustomFile(i, customField)" type="button"
                                                            icon="pi pi-times">
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-template>
                                    </p-fileUpload>
                                </ng-container>

                                <!-- Picture -->
                                <ng-container *ngSwitchCase="formControlListIds?.Picture">
                                    <p-fileUpload customUpload="true" class="fupload" previewWidth="100"
                                        chooseLabel="Choose" accept="image/*" [multiple]="true"
                                        [showUploadButton]="false" [showCancelButton]="false"
                                        (onSelect)="onCustomUpload($event, customField, 'image')">
                                        <ng-template pTemplate="file"></ng-template>
                                        <ng-template pTemplate="content">
                                            <ng-container
                                                *ngFor="let picture of (customField.value.customeAttachement||[]); let i = index;">
                                                <div class="p-fileupload-row p-mb-2">
                                                    <button pButton icon="fa fa-download"
                                                        (click)="downloadFile(picture.name, picture.content)"
                                                        class="p-button-link p-px-0 p-py-0">
                                                    </button>
                                                    <ng-container
                                                        *ngIf="picture.content && picture.content.startsWith('data') else localImage">
                                                        <img src="{{ picture.content }}" width="100" alt="card" />
                                                    </ng-container>
                                                    <ng-template #localImage>
                                                        <img [src]="picture.location" width="100" alt="card" />
                                                    </ng-template>
                                                    <ng-container *ngIf="picture.name.length > 15 else splitImageName">
                                                        <div [pTooltip]="picture.name">
                                                            {{ picture.name.substring(0, 14) }}...
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #splitImageName>
                                                        <div> {{ picture.name }} </div>
                                                    </ng-template>
                                                    <div>
                                                        {{ picture.sizeInBytes | fileSize }}
                                                    </div>
                                                    <div>
                                                        <button icon="pi pi-times" pButton
                                                            (click)="removeCustomFile(i, customField)" type="button"
                                                            icon="pi pi-times">
                                                        </button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-template>
                                    </p-fileUpload>
                                </ng-container>

                                <!-- Radio Button -->
                                <ng-container *ngSwitchCase="formControlListIds?.RadioButton">
                                    <ng-container *ngFor="let pickName of customField.value.pickListValues">
                                        <p-radioButton [value]="pickName" formControlName="value">
                                        </p-radioButton>&nbsp; {{ pickName }}
                                    </ng-container>
                                </ng-container>

                                <!-- Date Picker -->
                                <ng-container *ngSwitchCase="formControlListIds?.DatePicker">
                                    <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                        placeholder="mm/dd/yyyy" appendTo="body" dateFormat="mm/dd/yy" styleClass="w-100" 
                                        yearRange="1900:2100" [showTime]="false" formControlName="value">
                                    </p-calendar>
                                </ng-container>

                                <!-- Rating -->
                                <ng-container *ngSwitchCase="formControlListIds?.Rating">
                                    <p-rating [cancel]="false" formControlName="ratingId"></p-rating>
                                </ng-container>

                                <!-- Toggle Button -->
                                <ng-container *ngSwitchCase="formControlListIds?.ToggleButton">
                                    <p-inputSwitch formControlName="toggle"></p-inputSwitch>
                                </ng-container>
                            </ng-container>

                            <div *ngIf="isRequiredTouched(customField)" class="p-invalid">
                                <small>{{ customField.value.labelName }} is required</small>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Custom Attributes Fields End -->

            </div>
        </form>
    </ng-container>
    <ng-container *ngIf="casesViewDetails && checkedFields && crudType=='view'">

        <div class="header">
            <h5>
                {{ templateSections?.[0]?.name||'Cases Information'}}
            </h5>
        </div>

        <div class="card">
            <div class="p-grid p-pt-2">
                <ng-container *ngFor="let checkField of checkedFieldList">
                    <div *ngIf="checkField && checkField?.enabledInForm && casesViewDetails[checkField.formFieldname]"
                        class="p-col-12 p-md-6">
                        <div class="p-grid">
                            <div class="p-col-4 p-pt-0 p-pb-0">
                                <p>
                                    <strong>{{checkField.labelName}}</strong> <span *ngIf="checkField?.isRequired"
                                        class="required-sign p-pl-1">*</span>
                                </p>
                            </div>
                            <div class="p-col-8 p-pt-0 p-pb-0">
                                <p style="word-break: break-word; white-space: pre-line;">{{ casesViewDetails[checkField.formFieldname] }}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngFor="let checkField of  this.templateSections[0]?.customFields">
                    <div *ngIf="checkField && checkField?.enabledInForm && casesViewDetails.customAttributeValues[checkField.customAttributeId]"
                        class="p-col-12 p-md-6">
                        <div class="p-grid">
                            <div class="p-col-4 p-pt-0 p-pb-0">
                                <p>
                                    <strong>{{checkField.labelName}}</strong> <span *ngIf="checkField?.isRequired"
                                        class="required-sign p-pl-1">*</span>
                                </p>
                            </div>
                            <div class="p-col-8 p-pt-0 p-pb-0">
                                <p style="word-break: break-word; white-space: pre-line;">{{ casesViewDetails.customAttributeValues[checkField.customAttributeId] }}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>


        </div>


        <app-shared-activities-timeline [objectId]="casesViewDetails?.id" [selectedObject]="casesViewDetails"
            objectType="Cases" [hideRigthArrow]="true" [showActivityLoader]="false">
        </app-shared-activities-timeline>


    </ng-container>

    <ng-container *ngIf="detailsLoadingFailed">
        <div class="card view-details-error-message">
            <span class="pi pi-exclamation-circle" style="font-size: 25px;"></span>
            <p>{{ detailsErrorMessage }}</p>
        </div>
    </ng-container>

    <p-footer>
        <button type="button" pButton (click)="closeCasesDialog()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="crudType!='view'" type="button" pButton class="p-button-label" label="Save & View"
            (click)="saveCases('view')" [disabled]="formSubmitted"></button>
        <button *ngIf="crudType!='view'" type="button" pButton class="p-button-label" label="Save" (click)="saveCases()"
            [disabled]="formSubmitted"></button>
    </p-footer>
</p-dialog>


<!-- File Opener Modal -->
<app-shared-file-opener *ngIf="displayFilePreview" [modalDisplay]="displayFilePreview" [modalFile]="currentFile"
    (closeFilePreview)="closeFilePreview()">
</app-shared-file-opener>

<app-shared-manual-modal [displayPopup]="displayManualPopup"
    [colsList]="manualRuleColumnSetttings" [singleSelection]="true" [selectedObjectType]="selectedModule"
    [selectedTemplateType]="selectedTemplate" [selectedAccount]="selectedRecordList"
    (saveAssignDataclicked)="saveParentAccount($event)" (cancelClicked)="manualpopupCancelClicked()"
    (saveSettingClicked)="columnSettingSaved($event)">
</app-shared-manual-modal>
